
import { message } from "antd";

import { LinkedInStore } from "../../../../stores/LinkedInStore";
import linkedinService from "../../../../services/linkedin/LinkedInService";

export const LinkedInContextInitializers = {
    InitializeLinkedInChildApplication: async (linkedinStore: LinkedInStore, history: any, companyId?: number) => {

        const linkedInChildApplication = await linkedinService.GetLinkedInChildApplicationByCompanyId(companyId);
        linkedinStore.SetLinkedInChildApplication(linkedInChildApplication);
    }
}
